import { render, staticRenderFns } from "./ListCourt.vue?vue&type=template&id=28c20f86"
import script from "./ListCourt.vue?vue&type=script&lang=js"
export * from "./ListCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports